const SET_PRIMARY_INFO = 'PROFILE/SET_PRIMARY_INFO'
const CLEAR_PRIMARY_INFO = 'PROFILE/NAME_PRIMARY_INFO'
const SET_DISPLAY_PHOTO = 'PROFILE/SET_DISPLAY_PHOTO'
const SET_PREFERENCE_IDS = 'PROFILE/SET_PREFERENCE_IDS'
const ADD_CARD_DETAILS = 'PROFILE/ADD_CARD_DETAILS'
const SET_ACCOUNT_STATUS = 'PROFILE/SET_ACCOUNT_STATUS'
const DISPLAY_PROFILE_MODAL = 'PROFILE/DISPLAY_PROFILE_MODAL'
const SET_PROFILE_MODAL_PAGE = 'PROFILE/SET_PROFILE_MODAL_PAGE'
const SET_PROFILE_MODAL_DETAIL_PAGE = 'PROFILE/SET_PROFILE_MODAL_DETAIL_PAGE'
const SET_NOTIFICATION_COUNT = 'PROFILE/SET_NOTIFICATION_COUNT'
const SET_EMAIL_VERIFICATION_STATUS = 'PROFILE/SET_EMAIL_VERIFICATION_STATUS'
const SET_FAVORITE_MALLS = 'PROFILE/SET_FAVORITE_MALLS'
const SET_TRANSPORTATION_MALL = 'PROFILE/SET_TRANSPORTATION_MALL'
const SET_SURVEY_MODAL_STATUS = 'PROFILE/SET_SURVEY_MODAL_STATUS'
// TODO: add more action types if necessary

export {
  SET_PRIMARY_INFO,
  CLEAR_PRIMARY_INFO,
  SET_DISPLAY_PHOTO,
  SET_PREFERENCE_IDS,
  ADD_CARD_DETAILS,
  SET_ACCOUNT_STATUS,
  DISPLAY_PROFILE_MODAL,
  SET_PROFILE_MODAL_PAGE,
  SET_PROFILE_MODAL_DETAIL_PAGE,
  SET_NOTIFICATION_COUNT,
  SET_EMAIL_VERIFICATION_STATUS,
  SET_FAVORITE_MALLS,
  SET_TRANSPORTATION_MALL,
  SET_SURVEY_MODAL_STATUS,
  // TODO: export action types added later
}
